import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getSchema } from '../../api/schemas';
import { getElectricalPanelById } from '../../api/electricalPanels';

export interface SchemaEditorHeaderProps {
  projectId: number;
  schemaId: number;
  electricalPanelId?: number;
  schemaName?: string;
  panelName?: string;
}

export default function SchemaEditorHeader({
  projectId,
  schemaId,
  electricalPanelId,
  schemaName,
  panelName,
}: SchemaEditorHeaderProps) {
  const { data: schema } = useQuery({
    queryKey: ['schema', schemaId],
    queryFn: () => getSchema(schemaId),
    enabled: !!schemaId && !schemaName,
    staleTime: 5 * 60 * 1000,
  });

  const resolvedPanelId = electricalPanelId ?? schema?.electrical_panel_id;

  const { data: panel } = useQuery({
    queryKey: ['electrical-panel', resolvedPanelId],
    queryFn: () => getElectricalPanelById(resolvedPanelId!),
    enabled: !!resolvedPanelId && !panelName,
    staleTime: 5 * 60 * 1000,
  });

  const schemaTitle = schemaName || schema?.name || `Схема ${schemaId}`;
  const panelTitle = panelName || panel?.proj_id || panel?.name || 'Щит не указан';
  const projectBaseUrl = projectId > 0 ? `/projects/${projectId}` : '/projects';
  const schemaFocusUrl = schemaId ? `${projectBaseUrl}?focus=schema-${schemaId}` : projectBaseUrl;
  const panelFocusUrl = resolvedPanelId ? `${projectBaseUrl}?focus=panel-${resolvedPanelId}` : projectBaseUrl;

  return (
    <header className="h-10 border-b border-gray-200 bg-white flex items-center justify-between px-4 text-sm z-30 flex-shrink-0 relative">
      <div className="min-w-0 flex items-center gap-3">
        <Link
          to="/"
          className="w-8 h-8 rounded-md bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center text-lg transition-colors"
          title="На главную страницу"
        >
          🌀
        </Link>
        <Link
          to={schemaFocusUrl}
          className="font-semibold text-gray-900 truncate hover:text-blue-700 transition-colors"
          title="Перейти в проект и сфокусироваться на схеме"
        >
          {schemaTitle}
        </Link>
        <span className="text-gray-300">|</span>
        <Link
          to={panelFocusUrl}
          className="text-gray-600 truncate hover:text-blue-700 transition-colors"
          title="Перейти в проект и сфокусироваться на щите"
        >
          Щит: {panelTitle}
        </Link>
      </div>
    </header>
  );
}
